import { feedsApi } from '../../api/feeds';
export const feedListDate = (value) => {
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? String(value || '')
    : `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`;
};
export const feedInitialPage = (params) => {
  const n = Number(params.get('page'));
  return Number.isSafeInteger(n) && n > 0 ? n : 1;
};
export const uniqueFeeds = (items, includeHidden = false) => {
  const seen = new Set();
  return items.filter((item) => {
    if (!item || item.id == null || (!includeHidden && item.isHidden) || seen.has(String(item.id)))
      return false;
    seen.add(String(item.id));
    return true;
  });
};
export async function loadFeedPage(page, query, locale, signal) {
  let result = await feedsApi.list(page, query, signal, locale);
  if (!Array.isArray(result.items)) throw Error('Invalid feed list');
  const total = Number(result.totalPages ?? page);
  if (Number.isSafeInteger(total) && total > 0 && page > total) {
    result = await feedsApi.list(total, query, signal, locale);
    page = total;
    if (!Array.isArray(result.items)) throw Error('Invalid feed list');
  }
  const current = Number(result.currentPage ?? page),
    end = Number(result.totalPages ?? page);
  return {
    items: uniqueFeeds(result.items),
    next: current === page && Number.isSafeInteger(end) && end > page ? page + 1 : undefined,
  };
}
export function feedThumbnail(uri) {
  const match =
    /^https:\/\/kr\.object\.iwinv\.kr\/postpop\/([a-zA-Z0-9_-][a-zA-Z0-9._-]{0,254})$/.exec(
      uri || '',
    );
  return match ? `/api/images/thumbnail?v=1&key=${encodeURIComponent(match[1])}` : uri;
}
